import axios, { AxiosError } from "axios";
import type {
  AxiosInstance,
  // InternalAxiosRequestConfig,
  AxiosResponse,
} from "axios";
// import dayjs from "dayjs";
// import { jwtDecode } from "jwt-decode";
// import { decryptData, encryptData } from "@/plugins/crypto";
// import type { AuthData } from "@/types/auth.context";
// import { axiosAuth } from "./auth.client";

const baseURL = import.meta.env.VITE_SARLAFT_API_URL || "http://localhost:3000";

const axiosSarlaft: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// axiosSarlaft.interceptors.request.use(
//   async (
//     request: InternalAxiosRequestConfig
//   ): Promise<InternalAxiosRequestConfig> => {
//     const stored = localStorage.getItem("auth");
//     if (!stored) return request;

//     const auth: AuthData = decryptData(stored);
//     if (!auth?.access_token) return request;

//     const decoded: any = jwtDecode(auth.access_token);
//     const isExpired = dayjs.unix(decoded.exp).diff(dayjs()) < 1;

//     if (!isExpired) {
//       request.headers.set("Authorization", `Bearer ${auth.access_token}`);
//       return request;
//     }

//     try {
//       const { data } = await axiosAuth.post(`/auth/refresh`, null, {
//         headers: {
//           Authorization: `Bearer ${auth.access_token}`,
//         },
//       });

//       const newAuth: AuthData = { ...auth, access_token: data.access_token };
//       localStorage.setItem("auth", encryptData(newAuth));

//       request.headers.set("Authorization", `Bearer ${data.access_token}`);
//     } catch (error) {
//       localStorage.removeItem("auth");
//       window.dispatchEvent(new Event("auth:expired"));
//     }

//     return request;
//   },
//   (error) => Promise.reject(error)
// );

axiosSarlaft.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error || "Algo salió mal");
  }
);

export { axiosSarlaft };
